<ng-container *ngIf="!useRefreshedUi; else refreshedUi">

  <div id="advanced-filters" class="advanced-filters">
    <div class="advanced-filters-header">
      <div
        id="advanced-filters-title-div"
        class="advanced-filters-title-div"
        (click)="onClickAdvFilterDiv()"
      >
        <img
          class="select-box-search-box-icon"
          src="assets/filter-dropdown.svg"
          alt="filter-dropdown"
        />
        <div
          id="advanced-filters-header-title"
          class="advanced-filters-header-title"
        >
          Advanced Filters
        </div>
        <img
          class="select-box-search-box-icon"
          src="assets/arrow-down.svg"
          alt="down-arrow"
        />
      </div>

    <mat-chip-listbox id="selected-filter-list">
      <mat-chip
        id="selected-filters"
        *ngFor="let filter of getVal()"
        [removable]="true"
        (removed)="removeFilter(filter)"
        class="advanced-filters-chip-list"
      >
        <div class="chip-option" [id]="'selected-filter-option-' + filter">
          <div id="chip-text" class="text-blue font-medium">{{ filter }}</div>
          <mat-icon
            matChipRemove
            *ngIf="true"
            class="advanced-filters-chip-list-button"
            >cancel</mat-icon
          >
        </div>
      </mat-chip>
      <div *ngIf="this.flattenFilterOptions().length > 3">
        <mat-chip-option
          id="show-more"
          *ngIf="!showAllFilters"
          class="advanced-filters-chip-list-show-more"
          (click)="toggleShowAllFilters()"
          >Show more</mat-chip-option
        >
        <mat-chip-option
          id="show-less"
          *ngIf="showAllFilters"
          class="advanced-filters-chip-list-show-less"
          (click)="toggleShowAllFilters()"
          >Show less</mat-chip-option
        >
      </div>
    </mat-chip-listbox>

      <button
        type="button"
        id="clear-all"
        *ngIf="getVal().length > 1"
        class="clear-selected-filters"
        (click)="clearAllSelectedFilterOptions()"
      >
        Clear All
      </button>

      <!-- Pushes all preceding elements to the left -->
      <div class="advanced-filters-header-actions">
        <ng-content select="[advanced-filters-header-actions]"></ng-content>
      </div>
    </div>

    <ng-container
      *ngIf="
        filterGroups.length === 0;
        else productDetailsSection
      "
    >
      <div class="advanced-filters-body" *ngIf="toggleBody">
        <div
          id="advanced-filter-select-boxes"
          class="advanced-filter-select-boxes"
        >
          <div *ngFor="let filter of filterOptions">
            <select-box
              [id]="'adv-filters-select-' + filter.title"
              [title]="filter.title"
              [options]="filter.options"
              [(selectedOptions)]="selectedFilterOptions[filter.title]"
              [type]="filter.inputType"
              (updateSelectedOptions)="updateSelectedOptions($event)"
            >
            </select-box>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #productDetailsSection>
      <div *ngFor="let group of filterGroups">
        <div class="advanced-filters-body" *ngIf="toggleBody">
          <div class="advanced-filter-inner-heading pt-20">{{group.title}}</div>
          <div
            id="advanced-filter-select-boxes"
            class="advanced-filter-select-boxes"
          >
            <div *ngFor="let filter of group.filters">
              <select-box
                [id]="'adv-filters-select-' + filter.title"
                [title]="filter.title"
                [options]="filter.options"
                [(selectedOptions)]="selectedFilterOptions[filter.title]"
                (updateSelectedOptions)="updateSelectedOptions($event)"
              >
              </select-box>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div
      id="advanced-filters-footer"
      class="advanced-filters-footer shadow-[0_2px_0_0_theme(colors.border-gray)]"
      *ngIf="toggleBody || toggleFooter"
    >
      <div class="advanced-filters-buttons">
        <button
          id="adv-filter-apply"
          class="button-blue advanced-filter-button"
          (click)="applyFilters()"
        >
          Apply
        </button>
        <button
          id="adv-filter-reset"
          class="button-clear advanced-filter-button"
          (click)="resetFilters()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</ng-container>


  <ng-template #refreshedUi>
    <div id="advanced-filters" class="bg-white">
      <div class="flex gap-[10px] px-5 py-5 items-center">
        <!-- Unselected state -->
        <div *ngIf="!toggleBody"
          id="advanced-filters-title-div"
          class="gap-2 rounded border border-solid border-blue py-3 px-4 bg-white flex items-center cursor-pointer"
          (click)="onClickAdvFilterDiv()"
        >
          <img
            class="cursor-pointer"
            src="assets/shared-icons/neptune-icon-blue-advance-filter.svg"
            alt="filter-dropdown"
          />
          <div
            id="advanced-filters-header-title"
            class="text-sm font-normal leading-normal whitespace-nowrap text-blue"
          >
            Advanced Filters
          </div>
          <img
            class="cursor-pointer w-[10px]"
            src="assets/shared-icons/neptune-icon-blue-solid-chevron-down-advanced-filter.svg"
            alt="down-arrow"
          />
        </div>
        
        <!-- Selected state -->
        <div *ngIf="toggleBody"
          id="advanced-filters-title-div"
          class="gap-2 rounded border border-solid border-blue py-3 px-4 bg-blue flex items-center cursor-pointer"
          (click)="onClickAdvFilterDiv()"
        >
          <img
            class="cursor-pointer"
            src="assets/shared-icons/neptune-icon-white-advance-filter.svg"
            alt="filter-dropdown"
          />
          <div
            id="advanced-filters-header-title"
            class="text-sm font-normal leading-normal whitespace-nowrap text-white"
          >
            Advanced Filters
          </div>
          <img
            class="cursor-pointer w-[10px]"
            src="assets/shared-icons/neptune-icon-white-solid-chevron-down.svg"
            alt="down-arrow"
          />
        </div>
      </div>
    </div>
  </ng-template>
